import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContextService } from "../services/context.service";
import { IEvent, MatchService, MatchStatus } from "../services/match.service";
import { Subscription } from "rxjs";

declare let googletag;

@Component({
  selector: "app-match",
  templateUrl: "./match.component.html",
  styleUrls: ["./match.component.scss"],
})
export class MatchComponent implements OnInit, OnDestroy, AfterViewInit {
  teams: any = {};
  events: IEvent[] = [];
  stats: any[] = [];
  matchId: number;
  lastId = 0;
  _live = false;
  loading = true;

  get live(): boolean {
    return this._live;
  }

  set live(live: boolean) {
    this._live = live;
    this.context.setLive(this.live);
    if (this._live) {
      this.startLiveTimer();
    } else {
      this.stopLiveTimer();
    }
  }

  private contextSubscription: Subscription;
  private eventSubscription: Subscription;
  private routerSubscription: Subscription;

  constructor(
    private context: ContextService,
    private matchService: MatchService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.contextSubscription = this.context.contextChanged$.subscribe(
      (context) => {
        if (this.matchId !== context.matchId && context.matchId) {
          this.matchId = context.matchId;
          this.initData();
        }
      }
    );
    this.routerSubscription = this.route.params
      // .map((params) => params.id)
      .subscribe((params) => {
        // this.context.setMatchId(id);
        this.context.setMatchId(params.id);
      });
  }

  ngAfterViewInit() {
    // googletag.cmd.push(function() { googletag.display('div-banner_inferior'); });
    // googletag.cmd.push(function() { googletag.display('div-banner_superior'); });
  }

  ngOnDestroy() {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.stopLiveTimer();
  }

  scrollToStats() {
    const statsElement = document.querySelector("app-stats") as HTMLElement;
    const fixedHeader = document.querySelector("app-scoreboard header.small");
    const fixedHeaderMargin = fixedHeader ? fixedHeader.scrollHeight : 0;
    const statsTop = statsElement && statsElement.offsetTop;
    window.scrollTo({
      top: statsTop - fixedHeaderMargin,
      behavior: "smooth",
    });
  }

  // TODO: volver a sintaxis de promesas
  async initData() {
    this.loading = true;
    try {
      const gameData = await this.matchService.getGame(this.matchId);
      // Check if match is finished by its status
      let isFinished = [
        MatchStatus.Finished,
        MatchStatus.Cancelled,
        MatchStatus.Postponed,
        MatchStatus.Suspended,
      ].includes(gameData?.[0]?.status);
      this.matchService.finished = isFinished;
      this.matchService.matchStart = Date.parse(gameData[0].date);
      const teamsData = gameData && gameData[0];
      this.teams = teamsData;
      if (this.teams.home && !this.teams.home.players) {
        this.teams.home.players = [];
      }
      if (this.teams.visitor && !this.teams.visitor.players) {
        this.teams.visitor.players = [];
      }
      this.teams = this.setImages(this.teams);
      this.events = await this.matchService.getGameEvents(this.matchId);
      this.loading = false;

      // Check if match is finished by time
      const date = Date.parse(this.teams.date);
      //isFinished = isFinished && date && Date.now() >= date + 10800000;
      this.live = !isFinished;
      if (this.events.length) {
        this.lastId = this.events[this.events.length - 1].event_id;
      }
      this.updateQuarter();
      this.refreshStats();
    } catch (err) {
      this.loading = false;
      console.error(err);
      this.router.navigateByUrl("/not-found");
    }
  }

  // TODO: volver a sintaxis de promesas
  async refreshData() {
    try {
      const gameData = await this.matchService.getGame(this.matchId);
      const teamsData = gameData && gameData[0];
      this.teams = teamsData;
      if (!teamsData) {
        this.router.navigateByUrl("/not-found");
        return;
      } else {
        const finished = [
          MatchStatus.Finished,
          MatchStatus.Cancelled,
          MatchStatus.Postponed,
          MatchStatus.Suspended,
        ].includes(this.teams.status);
        if (finished) {
          this.live = false;
          this.stopLiveTimer();
        }
      }
      if (this.teams.home && !this.teams.home.players) {
        this.teams.home.players = [];
      }
      if (this.teams.home && !this.teams.home.players) {
        this.teams.home.players = [];
      }
      if (this.teams.visitor && !this.teams.visitor.players) {
        this.teams.visitor.players = [];
      }
      this.teams = this.setImages(this.teams);
      if (!this.live) {
        if (this.eventSubscription) {
          this.eventSubscription.unsubscribe();
          this.eventSubscription = null;
        }
        this.loading = true;
        this.events = await this.matchService.getGameEvents(this.matchId);
        this.loading = false;
        if (this.events.length) {
          this.lastId = this.events[this.events.length - 1].event_id;
        }
      }
    } catch (err) {
      console.error(err);
      this.loading = false;
      if (err.status === 404) {
        this.router.navigateByUrl("/not-found");
      }
    }
  }

  refreshStats() {
    this.matchService
      .getGameStats(this.context.getMatchId())
      .then((data) => {
        this.stats = data;
      })
      .catch((error) => {
        this.loading = false;
        console.error(error);
      });
  }

  hasStarted() {
    const date = Date.parse(this.teams && this.teams.date);
    return date && Date.now() > date;
  }

  setImages(match) {
    ["home", "visitor"].forEach((key) => {
      match[key].img = this.matchService.getTeamImg(match[key]);
      (match[key].players || []).forEach((p) => {
        p.img = this.matchService.getPlayerImg(match[key], p.id);
      });
    });
    return match;
  }

  private startLiveTimer() {
    if (!this.eventSubscription) {
      this.matchService.refreshEvent$.subscribe(() => {
        this.matchService
          .getGameEvents(this.matchId, this.lastId)
          .then((events) => {
            this.events = this.events.concat(events);
            if (this.events && this.events.length) {
              this.lastId = this.events[this.events.length - 1].event_id;
            }
            this.updateQuarter();
          })
          .catch((error) => {
            console.error(error);
          });
        this.refreshStats();
        this.refreshData();
      });
    }
    // We will go with a timer
    this.matchService.matchStart = Date.parse(this.teams.date);
    this.matchService.startTimer();
  }

  private stopLiveTimer() {
    this.matchService.stopTimer();
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  private updateQuarter() {
    if (this.events.length && this.teams) {
      const quarter =
        this.teams.status === MatchStatus.Finished
          ? MatchStatus.Finished
          : this.events[this.events.length - 1].quarter;
      if (this.context.getQuarter() !== quarter) {
        this.context.setQuarter(quarter);
      }
    } else {
      this.context.setQuarter(MatchStatus.NotStarted);
    }
  }
}
